export const brand = {
  name: "Fundred",
  tagline: "The Digital Operating System for Education",
  descriptor: "Fundred School Inf — one connected platform for payments, communication, finance, and digital services across the entire education ecosystem.",
  city: "Kampala",
  country: "Uganda",
  company: "Fundred",
  domain: "fundredsi.com",
  logoUrl: "/fpay.jpeg",
};

export const subBrands = [
  { name: "Fundred Pay", desc: "Payments" },
  { name: "Fundred Wallet", desc: "Digital wallets" },
  { name: "Fundred Market", desc: "School marketplace" },
  { name: "Fundred Finance", desc: "Billing & reconciliation" },
  { name: "Fundred Insights", desc: "Analytics & reporting" },
  { name: "Fundred Connect", desc: "Parent & school communication" },
  { name: "Fundred API", desc: "Developer platform" },
];
